import React, { ButtonHTMLAttributes } from 'react';
import { FaRegCheckCircle, FaRegCircle } from 'react-icons/fa';

import { Container } from './styles';

interface ISelectAltProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

const SelectAlt: React.FC<ISelectAltProps> = ({
  selected = false,
  ...rest
}) => {
  return (
    <Container {...rest} type="button" selected={selected}>
      {selected ? 'Selecionado' : 'Selecionar'}

      {selected ? <FaRegCheckCircle size={16} /> : <FaRegCircle size={16} />}
    </Container>
  );
};

export default SelectAlt;
